module.exports = __webpack_public_path__ + "img/9d4e5c8.jpg";